/**
*	@author Camilo
*	@since  26/10/2017
*   Modelo que se usa para crear option se select, se estandariza dos atributos que siempre se van a usar
**/
export class OpcionModel {
	
	constructor(public idOpcion:any, 
		public labelOpcion:string
		) {}

}


// WEBPACK FOOTER //
// D:/REPO/FacturacionWeb/src/app/main/content/Global/Opcion.model.ts